import { Link } from "react-router-dom";
import SEOHead from "@/components/SEOHead";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-6 pb-24">
      <SEOHead title="Page Not Found | All Time Paint & Plaster Co." description="The requested page could not be found." noIndex />
      <div className="text-center max-w-2xl">
        <p className="mb-4 text-clay text-sm">404</p>
        <h1 className="mb-8 font-heading text-4xl text-foreground">Page not found</h1>
        <nav className="flex flex-wrap justify-center gap-4" aria-label="Page not found navigation">
          <Button asChild variant="outline"><Link to="/">Home</Link></Button>
          <Button asChild variant="outline"><Link to="/services/">Services</Link></Button>
          <Button asChild><Link to="/book/">Book a Free Estimate</Link></Button>
        </nav>
      </div>
    </main>
  );
};

export default NotFound;
